__turbopack_context__.v({
  "actions": "ManagedConnectionNudgeCard-module__qVnG2a__actions",
  "badge": "ManagedConnectionNudgeCard-module__qVnG2a__badge",
  "card": "ManagedConnectionNudgeCard-module__qVnG2a__card",
  "checklist": "ManagedConnectionNudgeCard-module__qVnG2a__checklist",
  "checklistItem": "ManagedConnectionNudgeCard-module__qVnG2a__checklistItem",
  "dismissButton": "ManagedConnectionNudgeCard-module__qVnG2a__dismissButton",
  "main": "ManagedConnectionNudgeCard-module__qVnG2a__main",
  "quickPick": "ManagedConnectionNudgeCard-module__qVnG2a__quickPick",
  "quickPickAppName": "ManagedConnectionNudgeCard-module__qVnG2a__quickPickAppName",
  "quickPickCard": "ManagedConnectionNudgeCard-module__qVnG2a__quickPickCard",
  "quickPickList": "ManagedConnectionNudgeCard-module__qVnG2a__quickPickList",
  "quickPickRow": "ManagedConnectionNudgeCard-module__qVnG2a__quickPickRow",
  "root": "ManagedConnectionNudgeCard-module__qVnG2a__root",
  "titleGroup": "ManagedConnectionNudgeCard-module__qVnG2a__titleGroup",
});
